import MarketingDashboard from "../../../pages/MarketingDashboard";

export default function MarketingPage() {
  return <MarketingDashboard />;
}
